import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './components/search/search.component';
import { FacilitiesService } from '../../facilities/facilities.service';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [SearchComponent],
  providers: [FacilitiesService],
  exports: [
    SearchComponent
  ]
})
export class AutoCompleteFacilitiesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/auto-complete-facilities/auto-complete-facilities.module.ts